// extracted by mini-css-extract-plugin
export default {"iconsContainer":"DropDown_iconsContainer__VBRfC","icons":"DropDown_icons__C947q"};